import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { exchangeAuthSession } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const hasProcessed = useRef(false);
    const navigate = useNavigate();
    const { setUser } = useAuth();

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/", { replace: true });
            return;
        }
        const sessionId = match[1];

        exchangeAuthSession(sessionId)
            .then((user) => {
                setUser(user);
                toast.success(`Welcome, ${user.name}`);
                // Strip fragment and go home
                navigate("/", { replace: true, state: { user } });
            })
            .catch((e) => {
                toast.error(e?.response?.data?.detail || "Login failed");
                navigate("/", { replace: true });
            });
    }, [navigate, setUser]);

    return (
        <div
            className="min-h-screen flex items-center justify-center bg-black text-fa-cream font-mono text-sm"
            data-testid="auth-callback"
        >
            Signing you in…
        </div>
    );
}
